const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "kc_landing";

export const recordLanding = (pathname) => {
  if (pathname.startsWith("/admin") || sessionStorage.getItem(KEY)) return;
  sessionStorage.setItem(KEY, JSON.stringify({ page: pathname, referrer: document.referrer || "" }));
};

export const getLanding = () => JSON.parse(sessionStorage.getItem(KEY) || "{}");

export const trackComparionClick = () => {
  const dedupeKey = `kc_click_${window.location.pathname}`;
  if (sessionStorage.getItem(dedupeKey)) return;
  sessionStorage.setItem(dedupeKey, "1");
  fetch(`${API}/events/comparion-click`, {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ page: window.location.pathname, landing_page: getLanding().page || null })
  }).catch(() => {});
};
